// 一些奇奇怪怪的小提示
const Tips = [
    "不许炼铜，你这个 Hentai！",
    "粮食是最重要的资源，粮食缺乏会导致除农业外的产业瘫痪。",
    "你知咩，iron(铁)有熨斗的意思。",
    "你知咩，铜曾被称为“亦金”。",
    "你知咩，其实作者我还是B站的UP主哦！什么，你知道？那还不来点个关注？",
    "你可能已经注意到，每个人口每两秒会消耗 1 粮食。",
    "你可能已经注意到，多数建筑每建造一座都能增加 2 雇佣上限。",
    "其实，煤炭除了能用来烧矿，还能用来铺地。",
    "其实，在这游戏中，建造建筑最多只需要消耗 3 种资源。",
    "祭坛是古代用来祭祀神灵、祈求庇佑的特有建筑。"
]
export default Tips